$('document').ready(() => {

  function formatTweet(text){
    var via = (typeof twitterTag != "undefined" ? " @" + twitterTag : " @hechingerreport"),
      returnText = text+via,
      linkCharOffset = 21,
      arrayText = [];

    if (returnText.length + linkCharOffset <= 280){
      return returnText;
    } else {
      arrayText = text.split(" ");
      while ((returnText.length + linkCharOffset) > 280){
        arrayText.pop();
        returnText = arrayText.join(" ")+via;
      }
      return returnText;
    }
  }
});
